<template>
  <b-form-select
    v-model="selected"
    @change="$emit('change', selected)"
  >
    <option
      v-for="option in sortSelect(options)"
      :key="option.id"
      :value="option.id"
    >{{ option.name }}</option>
  </b-form-select>
</template>

<script>
import ajax from '@/resources/myApi';

export default {
  data() {
    return {
      selected: null,
      options: [],
    }
  },
  props: {
    initialValue: {
      type: [Number, String],
      default: 0,
    },
  },
  methods: {
    async getLookupValues() {
      const { data } = await ajax.get('api/ShippingProvider', {
        name: 'ShippingProviders',
      });

      if(data.hasOwnProperty('items')) { // If using pagination
        this.options = data.items
      } else {
        this.options = data;
      }
    }
  },
  async created() {
    // If initial value provided
    if(this.initialValue) this.selected = this.initialValue;

    await this.getLookupValues();
  }
}
</script>